
import { mapGetters } from 'vuex'
import { copyToClip, imLinkJump } from '~/utils/index'

export default {
    data () {
        return {
            labelList: []
        }
    },
    computed: {
        ...mapGetters({
            customerInfo: 'ry/customerInfo'
        })
    },
    props: {
        messageData: {
            type: Object,
            default: () => { }
        }
    },
    mounted () {
        this.labelList = Array.isArray(this.messageData.content.content.labelList)
            ? this.messageData.content.content.labelList.map(item => ({
                ...item,
                open: false
            }))
            : []
    },
    methods: {
        // 复制商品编号
        copyGoodsNo (val) {
            copyToClip(val, '已复制')
        },
        /**
         * 商品卡片的链接跳转
         */
        getImLinkJump (item) {
            return imLinkJump(item)
        },
        // 点击问题
        handleQuestion (labelItem) {
            // 若存在下级则打开
            if (labelItem.children?.length) {
                this.labelList = this.labelList.map(label => {
                    if (label.id == labelItem.id) {
                        label.open = !label.open
                    }
                    return label
                })
                return
            }

            const info = this.customerInfo
            const curConversation = {
                conversationType: info.conversationType,
                targetId: info.targetId
            }
            const _tempMsgItem = {
                d: labelItem.questionPrompt,
                n: 'text'
            }
            const labelPar = {
                action: {
                    goodsNo: this.messageData.content.content.goodsId,
                    imUserId: info.targetId,
                    labelId: labelItem.id
                }
            }
            this.$emit('sendSimple', curConversation, _tempMsgItem, labelPar)
        }
    }
}
